import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Components
import MyButton from '../../utils/MyButton';
import PostScream from '../scream/PostScream';
import Notifications from './Notifications';
import { useThemeContext } from '../../utils/ThemeContext';

// Redux
import { connect } from 'react-redux';

// MUI stuffs
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

// Icons
import HomeIcon from '@mui/icons-material/Home';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

function ThemeToggleButtonIcon() {
    const { isDark, toggleTheme } = useThemeContext();
    return (
        <IconButton
            color="inherit"
            onClick={toggleTheme}
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
            {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
    );
}

function ThemeToggleButtonText() {
    const { isDark, toggleTheme } = useThemeContext();
    return (
        <Button color="inherit" onClick={toggleTheme} title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
            {isDark ? 'Light' : 'Dark'}
        </Button>
    );
}

export class Navbar extends Component {
    render() {
        const { authenticated } = this.props;
        return (
            <AppBar>
                <Toolbar className="nav-container">
                    {authenticated ? (
                        <Box className="nav-actions">
                            <PostScream />
                            <MyButton tip="Home" component={Link} to="/" aria-label="Home">
                                <HomeIcon />
                            </MyButton>
                            <Notifications />
                            <ThemeToggleButtonIcon />
                        </Box>
                    ) : (
                        <Fragment>
                            <Button color="inherit" component={Link} to="/login">Login</Button>
                            <Button color="inherit" component={Link} to="/">Home</Button>
                            <Button color="inherit" component={Link} to="/signup">Signup</Button>
                            <ThemeToggleButtonText />
                        </Fragment>
                    )}
                </Toolbar>
            </AppBar>
        )
    }
}

Navbar.propTypes = {
    authenticated: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    authenticated: state.user.authenticated
});

export default connect(mapStateToProps)(Navbar);
